import { Component, forwardRef, Renderer2, ViewChild, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RoleService } from '../../../service/role/role.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectRoleComponent),
  multi: true,
};

@Component({
  selector: 'app-select-role',
  templateUrl: './select-role.component.html',
  styleUrls: ['./select-role.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectRoleComponent implements ControlValueAccessor {
    @Input() roleId: number;
    @Input() roleValueId: boolean;
    @ViewChild('input') textarea;

    public rolesOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public roleService: RoleService
    ) {
        this.page = 1;
        this.per_page = 1000;
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        this.getRoles(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getRoles(query?: string, filters?: any[]) {
        this.roleService.getRole(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const roles = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.rolesOptions = [];
                this.rolesOptions.push({id: undefined, name: 'Seleccione', company: undefined});
                roles.forEach(element => {
                    if (this.roleId === element.id) {
                        this.rolesOptions.push({id: element.id, name: element.name, selected: true, company: element.company});
                    } else {
                        this.rolesOptions.push({id: element.id, name: element.name, selected: false, company: element.company});
                    }
                });
            },
            error => {
                this.rolesOptions = [];
                this.rolesOptions.push({id: '', name: 'Error'});
            }
        );
    }

    getValue(role) {
        let value;
        if (this.roleValueId) {
            value = role.id;
        } else {
            value = role.name;
        }
        return value;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/roles/select-role/select-role.component.ts